<template>
  <div class="video-wrap">
    <!-- 播放视频的容器 -->
    <div class="play-wrap" v-show="showVideoModal">
      <p class="title">
        <span>视频预览</span>
        <a-icon class="close-icon" @click="closeVideoModal" type="close" />
      </p>
      <!-- 视频区域 -->
      <div class="video-container">
        <slot name="videoScale" ref="videoScale" />
      </div>
    </div>

    <div class="btn-group">
      <!-- 继续学习/一键暂停按钮 -->
      <slot name="toggle-btn" />
      <!-- 推送学习按钮 -->
      <slot name="push-btn" />
    </div>

    <!-- 缩略图列表 -->
    <a-tooltip
      placement="leftTop"
      :get-popup-container="getPopupContainer"
      :visible="showTips"
      overlay-class-name="diy-tip-style"
    >
      <template slot="title">
        <p class="title">
          温馨提醒
        </p>
        <p class="txt">
          请先选择片段，然后推送至学习机
        </p>
        <p class="close-tip">
          <span @click="showTips = false">知道了</span>
        </p>
      </template>
      <a-collapse
        class="group-table-wrap"
        expand-icon-position="left"
        v-model="activeKey"
        :bordered="false"
      >
        <template slot="expandIcon" slot-scope="props">
          <div>
            <SvgIcon v-if="!props.isActive" icon="play" class="play-svg" />
            <SvgIcon v-else icon="play" class="select-open-svg" />
          </div>
        </template>
        <a-collapse-panel class="collapse-item" v-for="(item, itemIndex) in collapseList" :key="String(item.collapseId)">
          <div slot="header" class="collapse-header">
            <span class="title">{{ item.title }}</span>
            <span class="num">共{{ item.num }}个</span>
          </div>
          <div class="v-list">
            <div class="select-btn" v-if="item.cardList.length > 0">
              <a-checkbox :indeterminate="item.indeterminate" :checked="item.checkAll" @change="(e) => onCheckAllChange(e, itemIndex, item)">
                全选
              </a-checkbox>
              <a type="link" :disabled="item.checkedList.length === 0" style="float:right;margin-top: 6px;" @click="cancelCheck(itemIndex)">
                取消勾选
              </a>
            </div>

            <!-- 片段卡片 -->
            <a-checkbox-group v-model="item.checkedList" v-if="item.cardList.length > 0" @change="(checkedListIds) => onChange(checkedListIds, itemIndex)">
              <div class="card-wrap" v-for="(card, cardIndex) in item.cardList" :key="card.index">
                <a-checkbox class="item-checked" :value="card.index" @change="itemCheckBoxChange" />
                <div class="card-box">
                  <p class="title">
                    <a-tooltip placement="topLeft" :title="card.name || '--'" overlay-class-name="draw_atooltip">
                      <span class="course-name">{{ card.name || '--' }}</span>
                    </a-tooltip>
                    <span @click="playVideo(itemIndex, cardIndex)" style="margin-top: 2px;cursor: pointer;">
                      <SvgIcon style="margin-left: 8px;" v-if="card.isPlay" icon="play" class="play-icon" />
                      <SvgIcon style="margin-left: 8px;" v-else icon="play" class="pause-icon" />
                    </span>
                    <!-- <span v-show="card.noStudy" class="not-required">选学</span> -->
                  </p>
                  <!-- 课程缩略图 -->
                  <img :src="card.firstImgUrl" class="thumbnail" style="pointer-events: none;" alt="" />
                </div>
              </div>
            </a-checkbox-group>

            <p v-else style="margin: 20px 0;text-align:center;">
              暂无数据
            </p>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </a-tooltip>
  </div>
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      activeKey: ['2'],
      showTips: false,
      showVideoModal: false,
      collapseList: [
        {
          collapseId: '1',
          title: '课前学',
          num: 0,
          checkAll: false,
          indeterminate: false,
          checkedList: [],
          cardList: []
        },
        {
          collapseId: '2',
          title: '课中学',
          num: 0,
          checkAll: false,
          indeterminate: false,
          checkedList: [],
          cardList: []
        },
        {
          collapseId: '3',
          title: '课后学',
          num: 0,
          checkAll: false,
          indeterminate: false,
          checkedList: [],
          cardList: []
        },
        {
          collapseId: '4',
          title: '不学',
          num: 0,
          checkAll: false,
          indeterminate: false,
          checkedList: [],
          cardList: []
        }
      ]
    }
  },

  watch: {
    list: {
      handler(val) {
        // 判断是否是点击播放引起的监听
        if (val) {
          // eslint-disable-next-line no-unused-vars
          let beforeIdx, middleIdx, afterIdx, notStudyIdx
          this.collapseList.forEach((collapse, collapseIdx) => {
            switch (collapse.collapseId) {
              case '1':
                beforeIdx = collapseIdx
                break
              case '2':
                middleIdx = collapseIdx
                break
              case '3':
                afterIdx = collapseIdx
                break
              case '4':
                notStudyIdx = collapseIdx
                break
              default:
                throw new Error('折叠面板Id无效')
            }
          })
          this.collapseList.forEach(item => {
            item.cardList = []
            item.checkedList = []
          })

          let isPushCompleted = false // false: 未推送过，true: 已推送
          val.forEach(k => {
            if (k.lastPush) isPushCompleted = true
            if (k.before) {
              this.collapseList[beforeIdx].cardList.push(k)
              if (k.lastPush) {
                this.collapseList[beforeIdx].checkedList.push(k.index)
              }
            }
            if (k.among) {
              this.collapseList[middleIdx].cardList.push(k)
              if (k.lastPush) {
                this.collapseList[middleIdx].checkedList.push(k.index)
              }
            }
            if (k.after) {
              this.collapseList[afterIdx].cardList.push(k)
              if (k.lastPush) {
                this.collapseList[afterIdx].checkedList.push(k.index)
              }
            }
            if (k.study) {
              this.collapseList[notStudyIdx].cardList.push(k)
              if (k.notStudyIdx) {
                this.collapseList[notStudyIdx].checkedList.push(k.index)
              }
            }
          })

          console.log('isPushCompleted', isPushCompleted)
          // 未推送过视频展示tips提示
          this.showTips = !isPushCompleted

          this.emitCheckedList()

          this.collapseList.forEach(item => {
            item.num = item.cardList.length
            item.indeterminate = item.checkedList.length && item.checkedList.length < item.cardList.length
            item.checkAll = item.checkedList.length === item.cardList.length
          })
        }
      },
      deep: true
    }
  },

  methods: {
    closeVideoModal() {
      try {
        this.$parent.$refs.videoScale.pause()
      } catch {
      } finally {
        this.showVideoModal = false
        this.clearPlayStatus()
      }
    },

    getPopupContainer() {
      return document.querySelector('.btn-group')
    },

    // 由于同一个片段id 可以存在于课前，课后..中,所以清除上一次播放状态只能遍历所有
    clearPlayStatus() {
      this.collapseList.forEach((item, itemIndex) => {
        item.cardList.forEach((card, cardIndex) => {
          this.collapseList[itemIndex].cardList[cardIndex].isPlay = false
          this.$forceUpdate()
        })
      })
    },

    playVideo(typeIndex, cardIndex) {
      if (this.collapseList[typeIndex].cardList[cardIndex].isPlay) {
        this.collapseList[typeIndex].cardList[cardIndex].isPlay = false
        this.showVideoModal = false
        this.$forceUpdate()
      } else {
        this.clearPlayStatus()
        this.collapseList[typeIndex].cardList[cardIndex].isPlay = true
        this.showVideoModal = true
        this.$forceUpdate()
      }
      // 获取视频片段参数并播放父组件中视频组件
      if (this.showVideoModal) {
        const videoFragment = this.collapseList[typeIndex].cardList[cardIndex]
        this.$parent.$refs.videoScale.voChangeTags([videoFragment])
      } else {
        this.$parent.$refs.videoScale.pause()
      }
    },
    cancelCheck(cancelIndex) {
      // 其他模块联动
      const ids = this.collapseList[cancelIndex].checkedList
      let targetIds = []
      let indeterminate = false
      let checkAll = false

      this.collapseList.forEach((k, i) => {
        targetIds = cancelIndex === i ? [] : this.setCancelIds(k.checkedList, ids),
        indeterminate = cancelIndex === i ? false : !!targetIds.length && targetIds.length < k.cardList.length,
        checkAll = targetIds.length === k.cardList.length

        Object.assign(this.collapseList[i], {
          checkedList: targetIds,
          indeterminate,
          checkAll
        })
      })

      this.emitCheckedList()
    },

    emitCheckedList() {
      const arr = []
      // 获取已选片段
      for (let i = 0; i < this.collapseList.length; i++) {
        if (this.collapseList[i].checkedList && this.collapseList[i].checkedList.length) {
          this.collapseList[i].checkedList.forEach(num => {
            const cardInfo = this.collapseList[i].cardList.find(card => card.index === num)
            if (cardInfo) arr.push(cardInfo)
          })
        }
      }
      this.$emit('checkedList', arr)
    },

    onChange(ids, i) {
      this.showTips = false
      const target = this.collapseList[i]
      target.indeterminate = ids.length < target.cardList.length
      target.checkAll = ids.length === target.cardList.length
    },

    itemCheckBoxChange(e) {
      this.$nextTick(() => {
        const { checked, value } = e.target
        if (checked) { // 勾选时
          this.collapseList.forEach((item, i) => {
            if (!item.checkedList.includes(value) && item.cardList.filter(card => card.index === value).length > 0) item.checkedList.push(value)
          })
        } else { // 取消勾选
          this.collapseList.forEach((item, i) => {
            const idx = item.checkedList.findIndex(k => k === value)
            if (idx !== -1) {
              item.checkedList.splice(idx, 1)
            }
          })
        }
        this.collapseList.forEach((k, i) => {
          Object.assign(this.collapseList[i], {
            indeterminate: !!k.checkedList.length && k.checkedList.length < k.cardList.length,
            checkAll: k.checkedList.length && k.checkedList.length === k.cardList.length
          })
        })
        this.emitCheckedList()
      })
    },

    // 移除arr1中存在的arr2数组
    setCancelIds(arr1, arr2) {
      const ids = arr1
      const targetArr = arr1.filter(k => arr2.includes(k))
      for (let i = ids.length; i >= 0; i--) {
        if (targetArr.includes(ids[i])) ids.splice(i, 1)
      }
      return ids
    },

    onCheckAllChange(e, itemIdx, item) {
      this.showTips = false
      const { checked } = e.target
      const ids = item.checkedList
      let targetIds = []
      let indeterminate = false
      let checkAll = false

      if (!checked) { // 取消全选联动
        this.collapseList.forEach((k, i) => {
          targetIds = itemIdx === i ? [] : this.setCancelIds(k.checkedList, ids),
          indeterminate = itemIdx === i ? false : !!targetIds.length && targetIds.length < k.cardList.length,
          checkAll = targetIds.length === k.cardList.length
          Object.assign(this.collapseList[i], {
            checkedList: targetIds,
            indeterminate,
            checkAll
          })
        })
      } else { // 全选联动
        const checkedAllIds = item.cardList.map(card => card.index)
        this.collapseList.forEach((k, i) => {
          targetIds = itemIdx === i ? this.collapseList[i].cardList.map(card => card.index) : this.setCheckedIds(k.checkedList, checkedAllIds, i), // 去重
          indeterminate = itemIdx === i ? false : !!targetIds.length && targetIds.length < k.cardList.length,
          checkAll = targetIds.length === k.cardList.length
          Object.assign(this.collapseList[i], {
            checkedList: targetIds,
            indeterminate,
            checkAll
          })
        })
      }
      this.emitCheckedList()
    },

    // arr1中选中相同片段
    setCheckedIds(otherIds, checkedAllIds, i) {
      const result = otherIds
      checkedAllIds.forEach(k => {
        if (this.collapseList[i].cardList.map(card => card.index).includes(k) && !otherIds.includes(k)) {
          result.push(k)
        }
      })
      return result
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.diy-tip-style) {
  top: 200px !important;
  .ant-tooltip-content {
    border-radius: 8px;
    background-color: #3262FD !important;
    .title {
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.04em;
      color: #FFFFFF;
    }
    .txt {
      font-family: 'Microsoft YaHei UI';
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 0.04em;
      color: #FFFFFF;
      margin: 8px 0 18px 0;
    }
    .close-tip {
      font-family: 'Microsoft YaHei UI';
      color: #FFFFFF;
      font-size: 12px;
      text-align: right;
      span {
        cursor: pointer;
      }
    }
    // 气泡颜色
    .ant-tooltip-inner {
        color: #333 !important;
        background-color: #3262FD !important;
    }
    .ant-tooltip-arrow {
      top: 40px;
    }
    // 气泡三角形颜色
    .ant-tooltip-arrow::before {
        background-color: #3262FD;
    }
  }
}
.video-wrap {
  padding: 20px;
  height: 100%;
  box-shadow: inset 1px 0px 0px #EBEDF0;
  background: #fff;
  .play-wrap {
    // width: 572px;
    height: auto;
    position: absolute;
    top: 52px;
    right: 288px;
    background: #FFFFFF;
    border: 1px solid #EBEDF0;
    box-shadow: 0px 2px 4px rgba(40, 41, 61, 0.04), 0px 8px 16px rgba(96, 97, 112, 0.16);
    border-radius: 12px;
    .title {
      display: flex;
      justify-content: space-between;
      padding: 14px 24px;
      font-family: 'Microsoft YaHei UI';
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.05em;
      color: #505873;
      box-shadow: inset 0px -1px 0px #EBEDF0;
    }
    .close-icon {
      color: #98A2B2;
      font-size: 18px;
      cursor: pointer;
    }
    .video-container {
      width: calc(100% - 48px);
      // margin: 24px auto;
      padding: 24px;
      height: calc(100% - 48px - 50px);
      background: #fff;
    }
  }
  .btn-group {
    display: flex;
    justify-content: space-between;
  }
  .group-table-wrap {
    margin-top: 8px;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 40px;
    background: #fff;
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #242731;
    }
    &::-webkit-scrollbar-thumb{
        width: 6px;
        height: 6px;
        opacity: 0.8;
        border-radius: 3px;
        background: #C7C7C7;
    }
    &::-webkit-scrollbar-track {
        background: #fff;
    }
    &::-webkit-scrollbar-button {
        background: #fff;
    }
    &::-webkit-scrollbar-corner {
        background: #fff;
    }
    :deep(.ant-collapse-header) {
      background: #fff;
      box-shadow: inset 0px -1px 0px #DBDEE2;
      padding-right: 0;
      padding-left: 20px;
      margin-bottom: 8px;
    }
    .collapse-header {
      background: #fff;
      .title {
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.06em;
        color: #505873;
      }
      .num {
        float: right;
        font-family: 'Microsoft YaHei UI';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.04em;
        color: #98A2B2;
      }
    }
    .card-wrap {
      display: flex;
      justify-content: space-between;
    }
    .card-box {
      width: 200px;
      height: 140px;
      background: #FFFFFF;
      border: 1px solid #EBEDF0;
      border-radius: 12px;
      overflow: hidden;
      margin-top: 8px;
      margin-left: 6px;
      .thumbnail {
        width: 100%;
        height: 107px;
      }
      .title {
        height: 33px;
        line-height: 33px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        .course-name {
          display: inline-block;
          max-width: 65%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .not-required {
          display: inline-block;
          font-family: 'Microsoft YaHei UI';
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          letter-spacing: 0.04em;
          color: #FF8800;
          padding: 0 4px;
          background: #FFF8E5;
          border-radius: 4px;
          white-space: normal;
          height: 20px;
          line-height: 20px;
          margin-left: 5px;
        }
      }
    }
    .play-svg {
      font-size: 12px;
      transform: scale(.6);
      fill: #505873;
    }
    .select-open-svg {
      font-size: 12px;
      transform: scale(.6) rotate(90deg);
      fill: #505873;
    }
    .play-icon {
      fill: #3262FD;
      font-size: 12px;
    }
    .pause-icon {
      fill: #505873;
      font-size: 12px;
    }
    .select-btn {
      display: flex;
      justify-content: space-between;
    }
    :deep(.item-checked) {
      display: flex;
      height: 16px;
      margin-top: 62px;
      .ant-checkbox {
        height: 16px;
      }
    }
    :deep(.ant-collapse) {
      background: #fff;
    }
    :deep(.ant-collapse-item) {
        background: #fff;
        border-bottom: none;
      }
    :deep(.ant-collapse-content-box) {
      background: #fff;
      padding: 0;
    }
    :deep(.ant-collapse-content-active) {
      min-height: 100px;
      background: #fff;
    }
    :deep(.ant-collapse-arrow) {
      display: inline-block;
      width: 10px;
      margin-left: -16px;
    }
  }
}
</style>
